export default {"src":"/_next/static/media/logo-simple-lucidity.43d65977.svg","height":32,"width":28,"blurWidth":0,"blurHeight":0};